// extracted by mini-css-extract-plugin
module.exports = {"standard":"BtnSubscriptionIcon__standard","premium":"BtnSubscriptionIcon__premium","free":"BtnSubscriptionIcon__free","svg":"BtnSubscriptionIcon__svg"};